import { get } from 'lodash/fp';
import { RequestError } from '../../../utils';

export default (error: RequestError | Error) => get(['data', 'errors'], error);
